/**
 * Field validation for Smart Room search — same style as LoginFormValidationRules.
 */
export default function validateSmartRoomSearch(values = {}) {
  const errors = {};
  const homeId = String(values.homeId || "").trim();
  const spaceId = String(values.spaceId || "").trim();

  if (!homeId) {
    errors.homeId = "Home ID is required";
  }

  if (!spaceId) {
    errors.spaceId = "Space ID is required";
  }

  return errors;
}
